import * as d3 from "d3";
import { Table } from "../Tabla";
import { NotificacionV2 } from "../NotificacionV2";
import _L from "../../../util/Labels";
import { DataUtilLocalStorage } from "../../../data/util/LocalStorage";
import { CTableStatusOrder } from "../TablaTypes";

export class TableReorderer<TDataTable> {
    private table: Table.Tabla<TDataTable>;
    private draggedColumnField: string = null;

    constructor(table: Table.Tabla<TDataTable>) {
        this.table = table;
    }

    private ExecuteReorderColumns(sourceField: string, targetField: string) {
        const columns = [...this.table._ColumnsHeaders];
        const sourceIndex = columns.findIndex(col => col.Field === sourceField);
        const targetIndex = columns.findIndex(col => col.Field === targetField);

        if (sourceIndex === -1 || targetIndex === -1) {
            console.warn("-d", "Column not found for reorder operation.");
            return;
        }

        const [removed] = columns.splice(sourceIndex, 1);
        columns.splice(targetIndex, 0, removed);

        this.UpdateColumnsOrderAndRefresh(columns);
    }

    private LoadColumnsOrderCfgFrom_LocalStorage() {
        let objTableOrderConfig = this.table._TableOrderCfgLS;
        if (!objTableOrderConfig[this.table._TableId]) {
            this.UpdateLocalStorageColumnsHeaders();
            return;
        }

        let reorderedColumnHeaders: Array<Table.ITableField<TDataTable>> = [];
        let tableOrder = objTableOrderConfig[this.table._TableId] as string[];
        tableOrder.forEach(column => {
            let colInConfig = this.table._ColumnsHeaders.find(d => d.Field === column);
            if (colInConfig) {
                reorderedColumnHeaders.push(colInConfig);
            }
        })
        this.table._ColumnsHeaders.forEach((d, index) => {
            if (!reorderedColumnHeaders.some(rCol => rCol.Field === d.Field)) {
                reorderedColumnHeaders.splice(index, 0, d);
            }
        })

        if (reorderedColumnHeaders.length) {
            this.table._SetColumnHeaders(reorderedColumnHeaders);
        }
    }

    private UpdateLocalStorageColumnsHeaders() {
        let objTableOrderConfig = this.table._TableOrderCfgLS;
        objTableOrderConfig[this.table._TableId] = this.table._ColumnsHeaders.map(columnHeader => columnHeader.Field);
        let jsonString = JSON.stringify(objTableOrderConfig);
        DataUtilLocalStorage._SetItem("winstatus", "tableorderconfig", jsonString);
    }

    private UpdateColumnsOrderAndRefresh(columns: Table.ITableField<TDataTable>[], orderData = false) {
        this.table._SetColumnHeaders(columns);
        this.UpdateLocalStorageColumnsHeaders();
        this.table._RefreshTableColumnsHeaders();
        this.table._UpdateDataView(orderData);
    }

    public _AttachDraggEvents(th: TSelectionHTML<"th">, enabled: boolean) {
        if (!enabled) {
            th.attr("draggable", "true")
                .on("dragstart", () => {
                    const event = d3.event as DragEvent;
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    NotificacionV2._Mostrar(_L("table.alert_nodrag"), "MESSAGE");
                })
            return;
        }
        th.attr("draggable", "true")
            .on("dragstart", (d: Table.ITableField<TDataTable>) => {
                const event = d3.event as DragEvent;
                event.dataTransfer.setData("text/plain", d.Field);
                event.dataTransfer.effectAllowed = "move";
                this.draggedColumnField = d.Field;
                th.classed("dragging", true);
            })
            .on("dragover", (d: Table.ITableField<TDataTable>) => {
                const event = d3.event as DragEvent;
                event.preventDefault();
                event.dataTransfer.dropEffect = "move";
                if (this.draggedColumnField && this.draggedColumnField !== d.Field) {
                    th.classed("drag_over", true);
                }
            })
            .on("dragleave", () => {
                th.classed("drag_over", false);
            })
            .on("drop", (d: Table.ITableField<TDataTable>) => {
                const event = d3.event as DragEvent;
                event.preventDefault();
                th.classed("drag_over", false);
                const sourceField = event.dataTransfer.getData("text/plain");
                const targetField = d.Field;

                if (sourceField && sourceField !== targetField) {
                    this.ExecuteReorderColumns(sourceField, targetField);
                }
            })
            .on("dragend", () => {
                th.classed("dragging", false);
                console.log()
                this.table._BAAA_TableHead.selectAll("th").classed("drag_over", false);
                this.draggedColumnField = null;
            })
    }

    public _ResetOrder() {
        const objTableOrderConfig = this.table._TableOrderCfgLS;
        objTableOrderConfig[this.table._TableId] = null;
        let jsonString = JSON.stringify(objTableOrderConfig);
        DataUtilLocalStorage._SetItem("winstatus", "tableorderconfig", jsonString);
        const configColumnsCfg = this.table._ConfigColumnsHeaders;
        const currentColumnOrder = this.table._ColumnsHeaders.find(d => d.Order != CTableStatusOrder.None);
        if (currentColumnOrder) {
            configColumnsCfg.map(d => {
                d.Order = currentColumnOrder.Field == d.Field ? currentColumnOrder.Order : CTableStatusOrder.None;
            })
        }
        this.UpdateColumnsOrderAndRefresh(configColumnsCfg, true);
    }

    public _LoadColumnsOrderCfgFromLS() {
        this.LoadColumnsOrderCfgFrom_LocalStorage();
    }
}